import { INSTAGRAM_DOMAIN } from '../cookies'
import { ParseError } from '../errors'
import { type AccountData, emptyAccount } from '../models'

const NETSCAPE_HEADER_MARKER = '# Netscape HTTP Cookie File'

function isNetscapeCookieLine(line: string): boolean {
  if (!line.includes('\t')) return false
  const cols = line.split('\t')
  if (cols.length < 7) return false
  return cols[0].includes('.')
}

export function splitNetscapeRecords(data: string): string[] {
  return data
    .split(/\n\s*\n/)
    .map((r) => r.trim())
    .filter((r) => r.length > 0)
}

export function canParseNetscape(data: string): boolean {
  if (data.includes(NETSCAPE_HEADER_MARKER)) return true
  for (const raw of data.split('\n')) {
    const line = raw.trim()
    if (!line || line.startsWith('#')) continue
    if (isNetscapeCookieLine(line) && line.includes(INSTAGRAM_DOMAIN)) return true
  }
  return false
}

export function parseNetscape(record: string): AccountData {
  const lines = record.split('\n')
  let loginLine = ''
  const cookieLines: string[] = []

  for (const raw of lines) {
    const line = raw.trim()
    if (!line || line.startsWith('#')) continue
    if (isNetscapeCookieLine(line)) {
      cookieLines.push(line)
    } else if (!loginLine) {
      loginLine = line
    }
  }

  if (!loginLine) {
    throw new ParseError('Missing login:password line')
  }

  const lp = loginLine.split(':')
  if (lp.length < 2 || lp.length > 3) {
    throw new ParseError(`Expected login:pass[:2FA], got ${loginLine}`)
  }
  const [login, password, twofaKey = ''] = lp

  const cookies: Record<string, string> = {}
  for (const line of cookieLines) {
    const cols = line.split('\t')
    const domain = cols[0]
    if (!domain.includes(INSTAGRAM_DOMAIN)) continue
    const name = cols[5]
    const value = cols[6]
    if (name && value) cookies[name] = value
  }

  if (!('sessionid' in cookies) || !('ds_user_id' in cookies)) {
    throw new ParseError('Missing required cookies: sessionid, ds_user_id')
  }

  return { ...emptyAccount(), login, password, twofaKey, cookies }
}
